export enum NotificationType {
	Hint,
	Success,
	Warning,
	Error
}
